import React from "react";

function RadioButton({ selected, onClick, label, name, disabled }) {
  return (
    <div className="flex items-center">
      <input
        id={name}
        type="radio"
        name={name}
        className="hidden"
        checked={selected}
        onClick={onClick}
        disabled={disabled}
      />
      <label htmlFor={name} className={`flex items-center ${disabled ? "" : "cursor-pointer"}`}>
        <span className="w-4 h-4 inline-block mr-1 rounded-full border border-grey ml-3"></span>
        {label}
      </label>

      <style>
          {`input[type="radio"]:checked + label span {
             background-color: #497EA0;
             box-shadow: 0px 0px 0px 2px white inset;
            }`
          }
        </style>
    </div>
  );
}

export default RadioButton;

